import { render, staticRenderFns } from "./evaluateList.vue?vue&type=template&id=1a98f3df&scoped=true&"
import script from "./evaluateList.vue?vue&type=script&lang=js&"
export * from "./evaluateList.vue?vue&type=script&lang=js&"
import style0 from "./evaluateList.vue?vue&type=style&index=0&id=1a98f3df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a98f3df",
  null
  
)

export default component.exports